import { userAgentDetailState } from '../../models/callModel';
import { Types } from '../action/action';

const initialState = {
  registration: 'pending',
  ua: ""
};

export const userAgentDetail = (state:userAgentDetailState  = initialState, action: any) => {
  const {
    type,
    payloads
  } = action;
  switch (type) {
  case Types.USER_AGENT_REDUCER:
    return {
      ...state, ua: payloads.ua, registration: payloads.registration
    };
  default:
    return state;
  };
};